import styled, { css } from 'styled-components'

import { ButtonWrapper } from '@/components/Button/Button.styles'
import { FieldTogglerWrapper } from '@/components/FieldToggler/FieldToggler.styles'
import { PointerWrapper } from '@/components/Pointer/Pointer.styles'

export const ConfirmationWrapper = styled.div`
  min-height: 100%;
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const ConfirmationInner = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  ${props =>
    props.theme.accessibilityMode &&
    css`
      flex-direction: row;
      width: 100%;
      align-items: flex-start;
    `};
`

export const ConfirmationInfo = styled.div`
  margin-bottom: 2rem;
`

export const ConfirmationElapsed = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.8rem;
  margin-top: 0.75rem;
  margin-bottom: 2.5rem;
  padding: 0.95rem 1.4rem;
  border-radius: 2px;
  background-color: rgba(10, 181, 0, 0.1);
  color: ${props => props.theme.color.global};

  ${props =>
    props.theme.accessibilityMode &&
    css`
      display: none;
    `};

  ${props =>
    props.theme.contrastMode &&
    css`
      background-color: transparent;
      border: 1px solid ${props => props.theme.color.global};
    `};

  strong {
    font-weight: 700;
  }
`

export const ConfirmationElapsedIcon = styled.span`
  display: inline-flex;
  color: ${props => props.theme.color.green};
  ${props =>
    props.theme.contrastMode &&
    css`
      color: ${props => props.theme.color.global};
    `};

  svg {
    width: 1.35em;
    height: 1.35em;
    fill: currentColor;
  }
`

export const ConfirmationSummary = styled.div`
  text-align: left;
  width: 60%;
  margin-bottom: 3rem;
  ${props =>
    props.theme.accessibilityMode &&
    css`
      flex: 1 1 auto;
      padding-right: 2rem;
    `};

  dl {
    display: flex;
    padding: 0;
    margin: 0;
    width: 100%;

    &:not(:last-child) {
      padding-bottom: 1rem;
      margin-bottom: 1rem;
      border-bottom: 1px solid ${props => props.theme.color.line};
    }

    dt,
    dd {
      margin: 0;
      padding: 0;
    }

    dt {
      padding-right: 1rem;
      flex: 0 0 40%;

      &:after {
        content: ':';
      }
    }

    dd {
      font-weight: 600;
      flex: 1 1 auto;
    }
  }
`

export const ConfirmationContent = styled.div`
  text-align: center;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  flex: 1 1 auto;
  position: relative;

  ${props =>
    props.theme.accessibilityMode &&
    css`
      justify-content: flex-end;
    `};

  h2 {
    font-size: 6rem;
  }

  h3 {
    font-size: 2.25rem;
  }

  ${PointerWrapper} {
    margin-top: auto;
  }

  ${FieldTogglerWrapper} {
    margin-bottom: 2.5rem;
  }

  ${props =>
    props.theme.accessibilityMode &&
    css`
      align-items: stretch;

      ${ButtonWrapper} {
        align-self: flex-start;
      }

      ${PointerWrapper} {
        position: absolute;
        right: 0;
        bottom: 0;
      }
      ${FieldTogglerWrapper} {
        margin-top: 2rem;
        margin-bottom: 0;
      }
    `};
`

export const ConfirmationFooter = styled.div`
  margin-top: auto;
`

export const ConfirmationGallery = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  margin-bottom: var(--view-padding-vertical);
  img {
    max-width: 40%;

    &:nth-child(2) {
      margin-top: 10%;
    }
  }
`

export const ConfirmationQr = styled.div`
  width: 14rem;
  flex-shrink: 0;
  margin-bottom: 1.5rem;

  ${props =>
    props.theme.accessibilityMode &&
    css`
      width: 12rem;
      margin-bottom: 0;
      margin-left: auto;
    `};

  span {
    font-weight: 600;
    font-size: 1.1rem;
    margin-bottom: 0.5rem;
    display: block;
  }

  img {
    display: block;
    width: 100%;
  }
`
